import React from 'react';
import { useIntl } from 'react-intl';

import { FormItemAutocomplete } from '../../../../components/forms/selects';

export default function AirlineAutoComplete({
  name,
  airlines,
  rules,
  isLoading,
}) {
  const { formatMessage } = useIntl();

  return (
    <FormItemAutocomplete
      name={name}
      rules={rules}
      options={airlines || []}
      floatingLabel={false}
      autofillFromOptions={false}
      formItemComponentProps={{
        formatLabel: x => (x?.code ? `${x?.code} - ${x?.text}` : x?.text),
      }}
      placeholder={formatMessage({
        id: 'book.newAirRetrieval.airline.placeholder',
      })}
      mapOptions={options =>
        options?.map(({ airlineCode, name: airlineName }) => ({
          code: airlineCode,
          label: airlineName,
          value: {
            code: airlineCode,
            text: airlineName,
          },
        })) || []
      }
      loading={isLoading}
    />
  );
}
